function createCookie({ name, value, days, isObject = false }) {
  const { host } = document.location;
  const domain = host.includes('www.') ? host.replace('www', '') : host;
  const isLocal = host.includes('localhost') || host.includes('192');
  // https://tools.ietf.org/html/rfc6265
  const actualDomain = isLocal ? host.split(':')[0] : domain;
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toGMTString()}`;
  }
  document.cookie = `${name}=${isObject ? JSON.stringify(value) : value} ${expires}; path=/; domain=${actualDomain}`;
}

function readCookie({ name }) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

module.exports = {
  createCookie,
  readCookie,
};
